module.exports = __webpack_public_path__ + "static/blog64-4bf5b9520e7127fab84c79cd81e7f712.png";